/**
 * This is an auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import type { ApiPlannedContainerAction, ApiPlannedContainerActionGroup } from '@Model';
import type { HttpActions, ListInfo, ListRequest, Result } from '@synqo/frontend-component-library';

/**
 * Calls the endpoints of PlannedContainerActionController.
 */
export class PlannedContainerActionRepository {
    constructor(private readonly http: HttpActions) {}

    /**
     * Calls POST /containers/planned-actions:query
     */
    public getPlannedActions(listRequest: ListRequest): Promise<Result<ListInfo<ApiPlannedContainerAction>>> {
        return this.http.post<Result<ListInfo<ApiPlannedContainerAction>>, ListRequest>('/containers/planned-actions:query', listRequest);
    }

    /**
     * Calls POST /containers/planned-actions/groups:query
     */
    public getPlannedActionGroups(listRequest: ListRequest): Promise<Result<ListInfo<ApiPlannedContainerActionGroup>>> {
        return this.http.post<Result<ListInfo<ApiPlannedContainerActionGroup>>, ListRequest>('/containers/planned-actions/groups:query', listRequest);
    }
}
